module.exports = "https://vote4-campaigns-cdn.fire-emblem-heroes.com/images/src/assets/images/top/389650ab514d27b996578aa1b32116fc.png";